import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import ScriptEndpointForm from '../script-endpoint-form/ScriptEndpointForm';
import RoutingService from '../../../services/RoutingService';
import IntegrationEndpointForm from '../integration-endpoint-form/IntegrationEndpointForm';
const RS = new RoutingService();
class EndpointEditor extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			endpoint: this.props.editing
		};
	}

	componentWillMount() {
		if (!this.data.endpoint) {
			RS.goToRoute('/endpoints');
		}
	}

	componentWillUnmount() {}

	render() {
		let { endpoint } = this.data;
		return (
			<div className="endpoints-editor-view animated fadeIn">
				{endpoint && endpoint.type.toLowerCase() === 'script' && <ScriptEndpointForm className="step-2" endpoint={endpoint} />}
				{endpoint && endpoint.type.toLowerCase() !== 'script' && <IntegrationEndpointForm className="step-2" endpoint={endpoint} />}
			</div>
		);
	}
}

export default EndpointEditor;



// WEBPACK FOOTER //
// ./src/views/endpoints-panel/endpoint-editor/EndpointEditor.js